const sortByAlphabet = (a, b) => {
  if (!a) return 1
  return a?.localeCompare?.(b)
}
export default sortByAlphabet
